import { useEffect, useRef, useState } from "react";
import handleError from "src/helpers/errorHandler";
import addFocusEvent from "src/helpers/focusHandler";
import sendRequest from "src/helpers/service";
import { DropdownOption } from "src/types/general";

export default function useBackgroundFetch(
  url: string,
  onSuccess?: (data: DropdownOption[]) => void
): DropdownOption[] | undefined | any {
  const [isFocused, setIsFocused] = useState(false);
  const [result, setResult] = useState<DropdownOption[] | undefined>(undefined);
  let timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const unsubscribe = addFocusEvent({
      onFocus: () => setIsFocused(true),
      onBlur: () => setIsFocused(false),
    });

    fetchData();
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (!isFocused) return;

    fetchData();
  }, [isFocused]);

  async function fetchData() {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      try {
        sendRequest.get({ url }).then((res) => {
          setResult(res.data);
          if (onSuccess) onSuccess(res.data);
        });
      } catch (error) {
        handleError(error);
      }
    }, 500);
  }

  return result;
}
